import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { overlayConfigFactory } from 'angular2-modal';
import { Component, ViewContainerRef,ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { FraudReportsService } from "./fraud-reports.service";
import { Router } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { LocalStorageService } from "angular-2-local-storage";
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { SearchTableState } from "../search-table-state";
import { Column } from "../column";
import { AlertService } from "../../../services/index";
import { ProgrammeService } from "../../../services/DataServices/programme.service";
import { PageStateService } from "../page-state.service";
import { BaseTableComponent } from "../base-table.component";
import { FraudReportEntries } from "./fraud-report-entries";
import {FraudReportModalComponent} from "./fraud-reports-modal";
import * as FileSaver from "file-saver";
import { PermissionService } from "../../../services/SecurityServices/permission.service";

@Component({
    template: require('./fraud-reports-table.html'),
    providers: [FraudReportsService, LocalStorageService, Modal],
    styles: [require('../table.css'), require('./fraud-reports-table.css')]
})

export class FraudReportsTableComponent extends BaseTableComponent implements OnInit, OnDestroy {
    private searchTableState: SearchTableState;
    private fraudReportEntries = [];
    private fraudReport: FraudReportEntries = null;
    private columns: Array<Column>;
    private busy: Subscription;
    private showFilter: boolean = false;
    private disableExportToExcel: boolean = false;
    private static lastRefreshed: string = 'fraud-report-last-refreshed';
    private dateFormat: string = 'yyyy-mm-dd';
    private datePickerOptions: IMyDpOptions = {
        height: '30px',
        dateFormat: this.dateFormat
    };

    constructor(
        vcRef: ViewContainerRef,
        private fraudReportService: FraudReportsService,
        private router: Router,
        private alertService: AlertService,
        private programmeService: ProgrammeService,
        private pageStateService: PageStateService,
        private localStorageService: LocalStorageService,
        private permissionService: PermissionService,
		private modal : Modal
    ) {
        super(localStorageService, fraudReportService.searchTableState);
        this.setColumns();
    }

    public goTo(value: number): void {
        if (value <= this.searchTableState.pageCount()) {
            this.searchTableState.pageChange(value);
            this.updateTable();
        }
    }

    ngOnInit() {
        let self: FraudReportsTableComponent = this;
        this.disableExportToExcel = !this.permissionService.userHasPermission('Fraud_ExportExcel');
        this.searchTableState = this.fraudReportService.searchTableState;
        this.searchTableState.currentPage = this.pageStateService.currentFraudReportPage;
        this.setPageSize('fraud-report-page-size');
        this.blankPage();
        this.setLastRefreshed(FraudReportsTableComponent.lastRefreshed);
        this.updateTable();
    }

    ngOnDestroy() {
        this.pageStateService.currentFraudReportPage = this.searchTableState.currentPage;
    }

    private setColumns() {
        this.columns = new Array<Column>();
        this.columns.push(new Column('Date Flagged', 'DateCreatedUtc'));
        this.columns.push(new Column('User', 'MobileNumber'));
        this.columns.push(new Column('Reason', 'FlaggedReason'));
        this.columns.push(new Column('Disabled', 'Status'));
        this.columns.push(new Column('Transactions Start Date', 'TransactionsStartDate'));
        this.columns.push(new Column('Transactions End Date', 'TransactionsEndDate'));
    }

    private blankPage() {
        this.fraudReportEntries = new Array<any>();      
        for (let i: number = 0; i < this.searchTableState.itemsPerPage; i++) {
            this.fraudReportEntries.push({});
        }
    }

    private filterTable(): void {
        if (this.searchTableState.fromDate && this.searchTableState.toDate && this.searchTableState.fromDate.getTime() > this.searchTableState.toDate.getTime()) {
            this.alertService.error('From Date cannot be more than To Date');
            return;
        }
        this.updateTable();
    }

    private updateTable(): void {
        if (this.searchTableState.updating) {
            return;
        }
        this.searchTableState.updating = true;
        let self: FraudReportsTableComponent = this;
        this.busy = this.fraudReportService.search().subscribe((message: Array<FraudReportEntries>) => {
            self.fraudReportEntries = message;
            self.searchTableState.updating = false;
        }, error =>  self.searchTableState.updating = false);
    }
    
    private exportExcel(): void {

        if (this.searchTableState.updating) {
            return;
        }
        this.searchTableState.updating = true;
        let self: FraudReportsTableComponent = this;
        this.fraudReportService.exportExcel().subscribe(blob => {
            self.searchTableState.updating = false;
            if (!blob) {
                return;
            }
            var fileName = 'FraudReports_' + this.searchTableState.lastRefreshed + '.xlsx';
            FileSaver.saveAs(blob, fileName);
            self.alertService.success('File generated successfully.');
        }, error =>  self.searchTableState.updating = false);

    }

    private refreshTable() {
        if (this.searchTableState.updating) {
            return;
        }
        this.updateLastRefreshed(FraudReportsTableComponent.lastRefreshed);
        this.updateTable();
    }

    onClick(fraudReportEntry?: FraudReportEntries) {
        var modal = this.modal.open(FraudReportModalComponent,  overlayConfigFactory({fraudReportEntry},BSModalContext)).then(dialog => dialog.result);
    }   
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/fraud-reports/fraud-reports-table.component.ts